import React from 'react';
import { Box, Button, Card, CardContent, Popover, Stack, Typography } from '@mui/material';

import { CURRENT_VERSION } from './OpenUserSettingsMenuItem';

// import { hasNewLayoutModeFeatureFlag } from '@paragon/login-tools';

export function ReleaseNotesPopover(props: { url?: string; anchorEl: HTMLElement | null; onClose(): void }) {
  // const showAndMore = false;
  const showDetailsLink = true;
  // const isFreeUser = useAppSelector(hasFreeSubscription);
  // const Changes = ({ children }: PropsWithChildren) => <ul>{children}</ul>;
  // const Change = ({ children }: PropsWithChildren) => <li>{children}</li>;

  return (
    <Popover
      open={!!props.anchorEl}
      anchorEl={props.anchorEl}
      onClose={props.onClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      transformOrigin={{ vertical: 'top', horizontal: 'left' }}
    >
      <Box sx={{ padding: 2, maxWidth: '800px' }}>
        <Typography variant="h4">Version {CURRENT_VERSION} - What&apos;s new?</Typography>

        <Stack spacing={2} sx={{ marginY: 2, maxWidth: '600px' }}>
          <Typography variant="h5" gutterBottom>
            Feature Updates
          </Typography>
          <Card>
            <CardContent style={{ paddingBottom: 16 }}>
              <Typography variant="h6">Truss Design Drawing Options in Design</Typography>
              You can now choose the same Truss Design Drawing options in Design&apos;s download dialog as in Projects:{' '}
              <strong>Format</strong> (<strong>Standard</strong> or <strong>Repair</strong>), <strong>File Type</strong>{' '}
              (<strong>Separate PDFs</strong> or <strong>Merged PDF</strong>), the drawing templates, and{' '}
              <strong>Share Project Snapshot (Hierarchy, Layout)</strong>. Click{' '}
              <strong>Truss Design Drawings PDF</strong> to open the options, then click{' '}
              <strong>Download Truss Design Drawings PDF</strong>. Truss Design Drawings are now in the{' '}
              <strong>Custom</strong> tab too, and the separate <strong>Repair Design Drawings PDF</strong> download is
              now the <strong>Repair</strong> format.
              <Box
                component="img"
                src="https://692471387-files.gitbook.io/~/files/v0/b/gitbook-x-prod.appspot.com/o/spaces%2FMHthYxtcRoRocZeurMok%2Fuploads%2FjTIvhf3iXQPW1TxSNr0H%2FTDD_Downloads.png?alt=media&token=5f927e6b-5009-4c61-ba1d-60743a770926"
                alt="The Truss Design Drawings PDF options in Design's download dialog"
                sx={{ display: 'block', mt: 1, maxWidth: '100%', maxHeight: 600 }}
              />
            </CardContent>
          </Card>
          <Card>
            <CardContent style={{ paddingBottom: 16 }}>
              <Typography variant="h6">Larger Selection Area When Cutting Roof Planes</Typography>
              You can now click anywhere within the bounds of a roof plane that has been defined to cut against it while
              in cutting mode.
              <Box
                component="img"
                src="https://692471387-files.gitbook.io/~/files/v0/b/gitbook-x-prod.appspot.com/o/spaces%2FMHthYxtcRoRocZeurMok%2Fuploads%2FKM3gepGPwZfO1sXZP1Rl%2Fimage.png?alt=media&token=ed702c47-f611-4d21-8ea3-0a3a15b82f31"
                alt="A defined roof plane selected by clicking within its bounds in cutting mode"
                sx={{ display: 'block', mt: 1, maxWidth: '100%', width: 375 }}
              />
            </CardContent>
          </Card>

          <Typography variant="h5" gutterBottom>
            Minor Updates
          </Typography>
          <Card>
            <CardContent style={{ paddingBottom: 16 }}>
              You can now download Truss Design Drawings through the Paragon API, with the same options as in Design and
              Projects: standard or repair drawings, your templates, and one merged PDF or separate PDFs.
            </CardContent>
          </Card>

          <Typography variant="h5" gutterBottom>
            Bug Fixes
          </Typography>
          <Card>
            <CardContent style={{ paddingBottom: 16 }}>
              <Box component="ul" sx={{ margin: 0, paddingLeft: 3, '& > li + li': { marginTop: 1 } }}>
                <li>Fixed an analysis error at some bottom chord splices for extended chord bearing checks.</li>
                <li>
                  Fixed roof planes attached to a work line sometimes not showing their plane tag, so you couldn&apos;t
                  select them, such as when cutting planes to define a ridge.
                </li>
                <li>
                  Fixed a crash that could occur after deleting ceiling planes in layouts with no truss envelopes.
                </li>
              </Box>
            </CardContent>
          </Card>
        </Stack>

        <Stack spacing={1} direction="row" sx={{ justifyContent: 'flex-end' }}>
          <Button variant="outlined" onClick={props.onClose}>
            Hide
          </Button>

          {props.url && showDetailsLink && (
            <Button variant="contained" href={props.url} target="_blank">
              See Full Release Notes
            </Button>
          )}
        </Stack>
      </Box>
    </Popover>
  );
}
